import React from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import HelloModal from 'common/components/hello-modal';
import * as types from 'hellospa/page/prep-and-send/data/types';
import styles from './styles.scss';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import { useSelector } from 'react-redux';
import HfReactHelper from 'common/utils/hf-react-helper';
import { trackHeapCustomEvent } from 'common/utils/heap';

const messages = defineMessages({
  title: {
    id: '',
    description: 'Title for template limit quota alert modal',
    defaultMessage: 'You\'ve used all {maxTemplateNumber} templates included in your plan',
  },
  noTemplateTitle: {
    id: '',
    description: 'Title for template limit quota alert modal',
    defaultMessage: 'There are no templates included in your plan',
  },
  pricing: {
    id: '',
    description: 'text for limit modal that lets you view our plans at their respective price',
    defaultMessage: 'View plans',
  },
  continue: {
    id: '',
    description: 'text for limit modal that lets you close the modal',
    defaultMessage: 'Create anyway',
  },
});

const TemplateQuotaAlert: types.TriggerComponent = ({ onSkip }) => {
  const intl = useIntl();
  let maxTemplateNumber = useSelector(selectors.maxTemplateNumber);
  if (!maxTemplateNumber) maxTemplateNumber = 0; // if ever undefined (NaN)
  const pricingUrl = HfReactHelper.urlHelper('info/pricing', 'hellosign');
  const title = (maxTemplateNumber === 0)
    ? intl.formatMessage(messages.noTemplateTitle)
    : intl.formatMessage(messages.title, { maxTemplateNumber });
  const handlePricingClick = () => {
    trackHeapCustomEvent('click_view_plans_p&s_modal');
  };

  return (
    <HelloModal
      width='540px'
      scrollable={false}
      isOpen={true}
      onRequestClose={onSkip}
      buttons={[
        {
          type: 'secondary',
          text: intl.formatMessage(messages.continue),
          onClick: onSkip,
        },
        {
          type: 'primary',
          text: intl.formatMessage(messages.pricing),
          buttonLink: pricingUrl,
          openInNewWindow: true,
          onClick: handlePricingClick,
        },
      ]}
      contentLabel={title}
    >
      <div className={styles.quotaText}>
        <FormattedMessage
          id=""
          description="text for a modal on prep and send that says you are over your template limit"
          defaultMessage="You can still create a template/template link, but it'll be locked until you upgrade your plan." />
        <br /><br />
        <FormattedMessage
          id=""
          description="text for a modal on prep and send that says the template will be locked or in test mode if you're an API user"
          defaultMessage="If you're an API user, you can use locked templates in test mode." />
      </div>
    </HelloModal>
  );
};

TemplateQuotaAlert.needsTrigger = (state, _formik) => {
  const isTemplateRequest = selectors.isTemplateRequest(state);
  const isAtTemplateLimit = selectors.isAtTemplateLimit(state);

  // since isTemplateRequest covers UI Template & Template Link
  // we don't need embedded template specific condition here
  return isTemplateRequest && isAtTemplateLimit;
};

export default TemplateQuotaAlert;
